export default __webpack_public_path__ + "static/media/job-count.84668c29.png";